import {Component, OnInit, Renderer2, ViewChild} from '@angular/core';
import {BoardsService} from "@components/boards/boards.service";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Params} from "@angular/router";
import {Subscription} from "rxjs";
import {SidebarService} from "@components/my-web-desk/sidebar/sidebar.service";
import {SidebarComponent} from "@components/my-web-desk/sidebar/sidebar.component";
import {MatDialog} from "@angular/material/dialog";
import {StatusSettingsComponent} from "@common-components/status-settings/status-settings.component";
import {NewBoardComponent} from "@components/boards/new-board/new-board.component";

export interface BoardColumns {
    id: '',
    tasks: [],
    title: '',
    status: '',
    color: 'pink'
}


@Component({
    selector: 'app-boards',
    templateUrl: './boards.component.html',
    styleUrls: ['./boards.component.css']
})


export class BoardsComponent implements OnInit {

    boards = [];
    columns = [];

    projectId = '';

    loader = false;
    sidebarState = true;




    constructor(private boardsService: BoardsService,
                private toastr: ToastrService,
                private route: ActivatedRoute,
                private sidebarService: SidebarService,
                private renderer: Renderer2,
                private matDialog: MatDialog) {
    }

    async ngOnInit() {

        this.route.params.subscribe((params: Params) => {
            this.projectId = params.projectId;
        });
        this.loader = true;
        await this.getBoards();
        this.loader = false;
    }

    getBoards() {
        return new Promise((resolve, reject) => {
            try {
                this.boardsService.getBoards(this.projectId).subscribe((response: BackendResponse) => {
                    if (response.type == 'success') {
                        this.boards = response.data;
                        resolve();
                    } else {
                        this.toastr.error('Došlo je do greške, molimo Vas obratite se korisničkoj podršci.');
                    }
                });
            } catch (e) {
                reject(e);
            }
        })
    }

    addBoard() {
        let dialog = this.matDialog.open(NewBoardComponent, {
            position: {top: '50'},
            autoFocus: true,
            maxHeight: '250px',
            data: {projectId: this.projectId}
        });
        dialog.afterClosed().subscribe(async (result) => {
            await this.getBoards();
        })

    }

}
